import React from 'react';
import { GO_TO_BOOK_TRAINING } from '../../routes/paths';
import { useHistory } from 'react-router-dom';

const GoToBookingBtn: React.FC<{ className?: string }> = ({ className }) => {
    const gotoRequestTraining = () =>
        window.open('https://calendly.com/eka-doctor-success/abdm-training', '_blank');

    return (
        <div
            onClick={gotoRequestTraining}
            className={`flex gap-8 rounded-8 cursor-pointer items-center space-x-4 h-36 btn-small bg-darwin-accent-bright-blue-800 text-white font-700 ${
                className ?? 'px-12 py-10'
            }`}
        >
            <svg
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="white"
                className="font-700 flex-shrink-0"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M4.17188 1.75H7.82812V0.734375C7.82812 0.404297 8.08203 0.125 8.4375 0.125C8.76758 0.125 9.04688 0.404297 9.04688 0.734375V1.75H10.0625C10.9512 1.75 11.6875 2.48633 11.6875 3.375V11.5C11.6875 12.4141 10.9512 13.125 10.0625 13.125H1.9375C1.02344 13.125 0.3125 12.4141 0.3125 11.5V3.375C0.3125 2.48633 1.02344 1.75 1.9375 1.75H2.95312V0.734375C2.95312 0.404297 3.20703 0.125 3.5625 0.125C3.89258 0.125 4.17188 0.404297 4.17188 0.734375V1.75ZM1.53125 11.5C1.53125 11.7285 1.70898 11.9062 1.9375 11.9062H10.0625C10.2656 11.9062 10.4688 11.7285 10.4688 11.5V5H1.53125V11.5Z" />
            </svg>
            Schedule training
        </div>
    );
};

export default GoToBookingBtn;
